import {useLazyQuery, gql} from '@apollo/client'
import {useDispatch, useSelector} from 'react-redux'
import {selectCountyChartVariables, setCountyChartVariables} from '../slices/countyChartSlice'

const countyQuery = gql`
  query sdohPopulation($SDOH_KEY: AlphabetOnly!, $STATE_COUNTY_FIPS_CODE: NumaricOnly!) {
    sdohPopulation(SDOH_KEY: $SDOH_KEY, STATE_COUNTY_FIPS_CODE: $STATE_COUNTY_FIPS_CODE) {
      DATA_BRICK
      option_name
      option_count_per_100k
    }
  }
`

export function useQuerySdohCountyChart(chartVariables) {
  const [
    getChartCountyData,
    {data: chartData, loading: loadingChart, refetch: refetchChart, error: errorLoadingChart}
  ] = useLazyQuery(countyQuery, {
    context: {clientName: 'longitudinal'},
    variables: {
      SDOH_KEY: chartVariables.sdohKey,
      STATE_COUNTY_FIPS_CODE: chartVariables.stateCountyCode
    },
    notifyOnNetworkStatusChange: true,
    errorPolicy: 'all'
  })
  return [getChartCountyData, {chartData, loadingChart, refetchChart, errorLoadingChart}]
}

export const useCountyChartProvider = () => {
  const dispatch = useDispatch()
  const countyChartVariables = useSelector(selectCountyChartVariables)

  const [getChartCountyData, chartCountyData] = useQuerySdohCountyChart(countyChartVariables)

  const setCountyChartVariablesAction = (variables) => {
    dispatch(setCountyChartVariables(variables))
  }

  return {
    getChartCountyData,
    chartCountyData,
    setCountyChartVariables: setCountyChartVariablesAction
  }
}
